<template>
    <transition name="slide-y">
        <div class="w-screen h-full fixed text-white overlay"
             :style="{ 'margin-left': `${overlayOffsetX}px`, 'margin-top': `${overlayOffsetY}px` }"
             v-show="value"
        >
            <row align="center" no-wrap>
                <btn icon
                     class="absolute z-10"
                     :style="{ top: closeButtonOffsetY+'px', left: closeButtonOffsetX+'px' }"
                     width="51"
                     height="51"
                     @click="hide()"
                >
                    <icon icon="close" color="white"></icon>
                </btn>
            </row>
            <slot></slot>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "Overlay",
        props: {
            value: {required: true},
            transition: {
                type: String,
                validator: (value) => ['slide-y', 'scale'].includes(value),
                default: 'scale'
            },
            closeButtonOffsetX: {
                type: [Number, String],
                default: 10
            },
            closeButtonOffsetY: {
                type: [Number, String],
                default: 10
            },
            overlayOffsetX: {
                type: [Number, String],
                default: 0
            },
            overlayOffsetY: {
                type: [Number, String],
                default: 0
            }
        },
        components: {
            row: () => import('@/components/display/Row.vue'),
            // column: () => import('@/components/display/Col.vue'),
            btn: () => import('@/components/Btn.vue'),
            icon: () => import('@/components/display/Icon.vue'),
        },
        methods: {
            show() {
                // let overlay = this.$el;
                // overlay.style.left = '0';
                // overlay.style.top = '0';
                document.documentElement.style.overflow = 'hidden';
                // document.body.scroll = 'no';
                this.$emit('input', true);
            },
            hide() {
                // let overlay = this.$el;
                // overlay.style.left = '-100%';
                // overlay.style.top = '0';
                document.documentElement.style.overflow = 'scroll';
                // document.body.scroll = 'yes';
                this.$emit('input', false);
            }
        },
        watch: {
            value(val) {
                if(val) {
                    this.show();
                } else {
                    this.hide();
                }
            }
        }
    }
</script>

<style scoped>
    .overlay {
        background-color: rgba(8, 36, 65, 0.95);
        /*transition: all 0.2s;*/
        z-index: 11;
        left: 0;
    }

    .slide-y-enter,
    .slide-y-leave-to {
        left: -100%;
    }
    .slide-y-enter-to,
    .slide-y-leave {
        left: 0;
    }
    .slide-y-enter-active,
    .slide-y-leave-active {
        transition: left 200ms ease-out;
    }

    /*.scale-enter,*/
    /*.scale-leave-to {*/
    /*    opacity: 0;*/
    /*    transform: rotateY(30deg) rotateX(10deg);*/
    /*}*/
    /*.scale-enter-to,*/
    /*.scale-leave {*/
    /*    opacity: 1;*/
    /*    transform: rotateY(0deg) rotateX(0deg);*/
    /*}*/
    /*.scale-enter-active,*/
    /*.scale-leave-active {*/
    /*    transition: opacity, transform 200ms ease-out;*/
    /*}*/
</style>